import React from "react";
import { SummaryDataValues } from "../../../../../../Rest_api/RestApi";

interface SummaryTilesChangedValuesProps {
    data?: SummaryDataValues;
}

const SummaryTilesChangedValues: React.FC<SummaryTilesChangedValuesProps> = ({
    data,
}) => {
    // Helper to format value with sign
    const formatValue = (val?: number) => {
        if (val === undefined || val === null) return "-";
        const formatted = Math.abs(val).toFixed(2);
        return val >= 0 ? `+${formatted}` : `-${formatted}`;
    };

    // Helper to determine if positive (for color)
    const isPositive = (val?: number) => {
        if (val === undefined || val === null) return true; // Default color?
        return val >= 0;
    };

    const displayData = [
        { label: "Wg. Avg. MCP Δ (Rs/MWh)", value: formatValue(data?.avg_mcp), isPos: isPositive(data?.avg_mcp) },
        { label: "MCV Δ (MWh)", value: formatValue(data?.mcv), isPos: isPositive(data?.mcv) },
        { label: "Avg. Buy Bid Δ (MWh)", value: formatValue(data?.avg_buy_bid), isPos: isPositive(data?.avg_buy_bid) },
        { label: "Avg. Sell Bid Δ (MWh)", value: formatValue(data?.avg_sell_bid), isPos: isPositive(data?.avg_sell_bid) },
        { label: "All India Demand Δ (MWh)", value: formatValue(data?.all_india_demand), isPos: isPositive(data?.all_india_demand) },
        { label: "All India Generation Δ (MWh)", value: formatValue(data?.all_india_generation), isPos: isPositive(data?.all_india_generation) },
        { label: "Peak Demand Δ (MW)", value: formatValue(data?.peak_demand), isPos: isPositive(data?.peak_demand) },
    ];

    return (
        <div className="flex items-stretch gap-2 w-full min-w-0">
            {/* Changed Values Badge */}
            <div
                className="flex items-center justify-center px-2 py-2 rounded-lg border border-[#3E97A9] text-[#3E97A9] text-xs font-medium text-center leading-tight flex-shrink-0"
                style={{ backgroundColor: "#EDF9FA", minWidth: "115px" }}
            >
                Change from <br />Previous
            </div>

            {/* Values Cards */}
            <div className="flex items-stretch gap-2 flex-1 min-w-0">
                {displayData.map((item, index) => (
                    <div
                        key={index}
                        className="flex flex-col justify-center px-2 py-2 bg-white rounded-lg border border-[#DFEAF2] flex-1 min-w-0"
                    >
                        <div className="flex items-center gap-1 min-w-0">
                            <span className="text-[10px] text-[#3E97A9] truncate">
                                {item.label}
                            </span>
                        </div>
                        <div
                            className={`text-sm font-semibold truncate ${item.isPos ? "text-[#22C55E]" : "text-[#F1935C]"
                                }`}
                        >
                            {item.value}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default SummaryTilesChangedValues;
